<template>
  <div class="cll__body">
    <!-- Products Module -->
    <div v-if="!productLoader" class="cll_products">
      <template v-for="product in sortedProducts" :key="product.handle">
        <ProductCard
          type="TypeB"
          v-if="product.product_type != 'card'"
          :product="product"
          :quickviewBtn="true"
          :showOOSbadge="true"
          gtmTrackId="PLP: Product Card"
          :collectionHandle="data.handle"
          :collectionTitle="data.title"
        />
      </template>
    </div>
    <div v-else class="cph__products">
      <svg v-for="index in 12" :key="index" class="cph__product">
        <use xlink:href="#icon-product-loader"></use>
      </svg>
    </div>
  </div>
</template>

<script setup>
  import { computed, toRefs, ref, onMounted, onUnmounted } from 'vue';
  import { useStore } from 'vuex';
  import ProductCard from '../global/product-card/index.vue';

  const props = defineProps({
    data: {
      type: Object,
      required: true,
    },
  });

  const { data } = toRefs(props);

  const store = useStore();
  const collectionData = ref(data.value);

  onMounted(() => {
    store.dispatch('fetchWishlistItems');
    window.addEventListener('refreshWishlist', refreshWishlist);
  });

  onUnmounted(() => {
    window.removeEventListener('refreshWishlist', refreshWishlist);
  });

  const refreshWishlist = () => {
    store.dispatch('fetchWishlistItems');
  };

  const sortedProducts = computed(() => {
    const { products } = collectionData.value;

    let modfiedProductsData = products.filter((product) => product.product_type != 'card');

    return modfiedProductsData.sort((a, b) => {
      const hasBISA = a.tags?.some((tag) => tag.toLowerCase().startsWith('bis:'));
      const hasBISB = b.tags?.some((tag) => tag.toLowerCase().startsWith('bis:'));
      const availableA = (a.available || hasBISA) ? 1 : 0;
      const availableB = (b.available || hasBISB) ? 1 : 0;
      return availableB - availableA;
    });
  });
</script>
